import { getSVG } from './components/icons-loader.js';
import { slickSliderGenerator, displayBrandSliderOnLoad} from './components/sliders.js';
import { displayCookieBanner } from './components/cookies-banner.js';
import { handleDemoFormOrBot } from './components/get-a-demo.js';


document.addEventListener("DOMContentLoaded", function () {
  slickSliderGenerator('brand', '.logos-container');
  displayBrandSliderOnLoad();
  getSVG();
  displayCookieBanner();
  handleDemoFormOrBot();
});
